import { TradingTab, TradingTabsGroup } from '@trading-ui/core';
import { useTranslation } from 'react-i18next';

import useSettingsStore from '../../store/useSettingsStore';

import * as styles from './TabsGroup.css';

export default function TabsGroup() {
  const selectedTab = useSettingsStore((state) => state.selectedTab);
  const setSelectedTab = useSettingsStore((state) => state.setSelectedTab);

  const { t } = useTranslation();

  return (
    <TradingTabsGroup
      textColor="primary"
      indicatorColor="primary"
      className={styles.tabGroup}
      value={selectedTab}
      onChange={(_, value) => setSelectedTab(value)}>
      <TradingTab index={0} label={t('settings.moeveActionsTab.title')} value={0} className={styles.tab} />
      <TradingTab index={1} label={t('settings.companyDetailsTab.title')} value={1} className={styles.tab} />
      <TradingTab index={2} label={t('settings.pricingIndicesTab.title')} value={2} className={styles.tab} />
    </TradingTabsGroup>
  );
}
